
<!-- <div class="select-index">
  <label for="cname">Select Index</label> 
-->
  <!--<div class="select-container">
    <select class="select" name="indexId" [(ngModel)]="utilityobj.indexId">
      <option value="1" Selected>Writs 1911-1966</option>
      <option value="2">Attachments 1967 on</option>
      <option value="3">City Tax Maps</option>
      <option value="4">Chronological Day Books</option>
    </select>
  </div> -->
  <div class="index-list">
    <dx-list itemSize="20" class="parties-viewport" [dataSource]="listItems" itemTemplate="Indexes" (onItemClick)="ItemClick($event)"
             [useNativeScrolling]="true" showScrollBar="onScroll" [selectedItems]="[listItems[3]]" pageLoadMode="scrollBottom">
      <div class="item-parties" *dxTemplate="let r of 'Indexes'" style="padding:1px;">
        <!--{{r.id}} - {{r.name}}-->
        {{r.name}}
      </div>
    </dx-list>
  </div>
